import {
  findUploadDocumentHistoryByService,
  getAllPendingDocumentTypesService,
} from '@services/contract';
import { loadingRequest, loadingSuccess } from '@stores/global/actions';
import { call, put, takeLatest, all } from 'redux-saga/effects';
import {
  setAllDocumentTypesDataAction,
  setFilterFindUploadDocumentHistoryConfig,
  setFindUploadDocumentHistoryDataAction,
} from './actions';
import {
  GET_ALL_DOCUMENT_TYPES_DATA,
  GET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA,
} from './constants';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig';
import { hasValue } from '@helpers/utils/utils.js';

export function* getFindUploadDocumentHistory({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(findUploadDocumentHistoryByService, payload);
    yield put(loadingSuccess());

    if (hasValue(response)) {
      yield put(setFindUploadDocumentHistoryDataAction(response));
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAllDocumentTypes({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getAllPendingDocumentTypesService, payload);
    yield put(loadingSuccess());

    yield put(setAllDocumentTypesDataAction(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export default function* eRecruitmentSaga() {
  yield takeLatest(
    GET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA,
    getFindUploadDocumentHistory,
  );
  yield takeLatest(GET_ALL_DOCUMENT_TYPES_DATA, getAllDocumentTypes);
}
